const assetHelper={}

const getNewAssetNo=(assets)=>{
    let result="NEW0001"
  
    if(!assets || assets.length==0){
        return result
    }
    else{
        
       var asset_desc= assets.sort(function (a, b) {
            if (a.asset_no > b.asset_no) {
                return -1;
            }
            if (b.asset_no > a.asset_no) {
                return 1;
            }
            return 0;
        })

      let max_asset_no= asset_desc[0].asset_no.replace("NEW",'')
      result="NEW" +  ("000" +(parseInt(max_asset_no)+1).toString()).slice(-4)
    }

    return result
}

const getNewAssetGroupNo=(assets)=>{
    let result="AG0001"
  
    if(!assets || assets.length==0){
        return result
    }
    else{
        
       var asset_desc= assets.sort(function (a, b) {
            if (a.asset_grouping > b.asset_grouping) {
                return -1;
            }
            if (b.asset_grouping > a.asset_grouping) {
                return 1;
            }
            return 0;
        })

      let max_asset_grouping= asset_desc[0].asset_grouping.replace("AG",'')
      result="AG" +  ("000" +(parseInt(max_asset_grouping)+1).toString()).slice(-4)
    }

    return result
}

const generateAssets=(assetNew, currentAssets)=>{
    let result=currentAssets || []
    let assetGroupNo=getNewAssetGroupNo(currentAssets)
    let asset_start=1 
    let asset_qty=1 

    if(assetNew.start_sequence && assetNew.start_sequence.length>0){
        asset_start = parseInt(assetNew.start_sequence)
    }

    if(assetNew.no_of_similar_asset && assetNew.no_of_similar_asset.length>0){
        asset_qty = parseInt(assetNew.no_of_similar_asset)
    }

    let i=0
    let last_asset_no=parseInt(getNewAssetNo(currentAssets).replace('NEW',''))

        for(i=0;i < asset_qty;i++){
            //let asset_index=(asset_start-1) + i
            let assetNo="NEW" +  ("000" + (last_asset_no + i).toString()).slice(-4)

            let asset={...assetNew,
                asset_no: assetNo,
                asset_grouping: assetGroupNo,
                asset_sub_grouping: "SAG" + (i+1).toString()
            }

            result.push(asset)
        }
    
    return {
        assets_All : [...result],
        assets_New : [...result.filter(f=>f.asset_grouping==assetGroupNo)]
    }
}

assetHelper.getNewAssetNo=getNewAssetNo
assetHelper.getNewAssetGroupNo=getNewAssetGroupNo
assetHelper.generateAssets=generateAssets

export default assetHelper